import React, { useState, useEffect } from "react";
import { Row, Col, Input, Checkbox, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import API_MANAGER from "../../API";

function SearchListItem({ item, setFilters, filters }) {
  const [expand, setExpand] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(null);
  const [selectedListCount, setSelectedListCount] = useState(0);
  
  const getData = async () => {
    try {
      if (item?.value === "CITIZENSHIP") {
        setData(item?.options);
      } else if (item?.value === "STATE" || item?.value === "LOCATION") {
        const params = search ? { search: search } : {};
        const response = await API_MANAGER.getCandidateLocations(params);
        
        const locations = response?.data?.data || [];
        
        if (!Array.isArray(locations) || locations.length === 0) {
          setData([]);
          return;
        }
        
        const tempData2 = locations.map((locationString) => {
          if (typeof locationString === 'string') {
            const parts = locationString.split(',').map(part => part.trim());
            if (parts.length >= 3) {
              const suburb = parts[0];
              const state = parts[1];
              const postalCode = parts[2];
              return {
                label: `${suburb}, ${state}, ${postalCode}`,
                value: locationString,
                fullLocation: locationString,
                suburb: suburb,
                state: state,
                postalCode: postalCode,
              };
            } else if (parts.length === 2) {
              return {
                label: locationString,
                value: locationString,
                fullLocation: locationString,
                suburb: parts[0],
                state: parts[1],
              };
            } else {
              return {
                label: locationString,
                value: locationString,
                fullLocation: locationString,
              };
            }
          }
          return null;
        }).filter((item) => item !== null && item.label && item.label.trim() !== "");
        
        setData(tempData2);
      } else {
        const params = {
          limit: 20000,
          sort: "name",
          type: item?.value,
          search: search,
        };
        const response = await API_MANAGER.getTagsBySearch(params);
        if (item?.value === "GENDER" || item?.value === "LICENCE_CLASS") {
          const tempData2 = response?.data?.data?.tags?.map((e) => {
            return {
              label: e?.name,
              value: e?.name,
            };
          });

          setData(tempData2);
        } else {
          const tempData = response?.data?.data?.tags?.map((e) => {
            return {
              label: e?.name,
              value: e?._id,
            };
          });

          setData(tempData);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    getData();
  }, [item?.value, search]);

  useEffect(() => {
    const filterKey = item?.label || item?.name?.toLowerCase();
    const selectedItems = filters[filterKey] || [];
    setSelectedListCount(selectedItems.length);
  }, [filters, item]);

  const handleCheckboxChange = (value, checked) => {
    const filterKey = item?.label || item?.name?.toLowerCase();
    const currentFilters = { ...filters };
    const currentValues = currentFilters[filterKey] || [];

    if (checked) {
      currentFilters[filterKey] = [...currentValues, value];
    } else {
      currentFilters[filterKey] = currentValues.filter((v) => v !== value);
    }

    if (currentFilters[filterKey].length === 0) {
      delete currentFilters[filterKey];
    }

    setFilters(currentFilters);
  };

  const clearAll = () => {
    const filterKey = item?.label || item?.name?.toLowerCase();
    const currentFilters = { ...filters };
    delete currentFilters[filterKey];
    setFilters(currentFilters);
  };

  const filterKey = item?.label || item?.name?.toLowerCase();
  const selectedValues = filters[filterKey] || [];

  return (
    <div className="searchListItem">
      <Row justify="space-between" align="middle">
        <Col>
          <span className="title">{item?.name}</span>
        </Col>
        <Col>
          <Row align="middle" gutter={8}>
            {selectedListCount > 0 && (
              <Col>
                <span style={{ color: "#1890ff", fontSize: "14px" }}>
                  {selectedListCount} selected
                </span>
              </Col>
            )}
            <Col>
              <DownOutlined
                onClick={() => setExpand(!expand)}
                style={{
                  cursor: "pointer",
                  transform: expand ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      {expand && (
        <>
          <Row style={{ marginTop: "10px" }}>
            <Col span={24}>
              <Input.Search
                placeholder="Search"
                allowClear
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onSearch={getData}
              />
            </Col>
          </Row>
          {selectedListCount > 0 && (
            <Row style={{ marginTop: "10px" }}>
              <Col>
                <span
                  onClick={clearAll}
                  style={{
                    color: "#1890ff",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  Clear all
                </span>
              </Col>
            </Row>
          )}
          <Row className="checkBoxContainer" style={{ marginTop: "10px" }}>
            <Col span={24}>
              {data?.map((e, key) => {
                const isChecked = selectedValues.includes(e?.value);
                return (
                  <div key={key} className="searchListItems">
                    <Checkbox
                      checked={isChecked}
                      onChange={(event) =>
                        handleCheckboxChange(e?.value, event.target.checked)
                      }
                    >
                      {e?.label}
                    </Checkbox>
                  </div>
                );
              })}
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default SearchListItem;
